export const getCurrency = () => window.top!.__INITIAL_STATE__.account.currency;
export const getTimeZone = () => window.top!.__INITIAL_STATE__.account.timeZone;
export const getCountry = () => window.top!.__INITIAL_STATE__.account.country;
export const getIsExpiredDemo = () => window.top!.__INITIAL_STATE__.account.isExpiredDemo;
export const getIsVoipActive = () => window.top!.__INITIAL_STATE__.account.isVoipActive;
export const hasBookkeepingIntegration = () => !!window.top!.__INITIAL_STATE__.account.bookkeeping;
export const isTrial = () => window.top!.__INITIAL_STATE__.account.isTrial;
